import { Box, HStack, Text } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants/primitives';

export const ContentWrapper = Box.withConfig({
  width: '100%',
  justifyContent: 'center',
  padding: '$4',
  textAlign: 'center',
  alignItems: 'center',
});

export const ContentWrapperDesktop = Box.withConfig({
  width: '500px',
  justifyContent: 'center',
  textAlign: 'center',
  alignItems: 'center',
});

export const ContentText = Text.withConfig({
  textAlign: 'center',
  marginBottom: '$10',
});

export const ContentHeader = Box.withConfig({
  _text: {
    variant: 'headerTwo',
    fontSize: 'lg',
    textAlign: 'center',
  },
  marginBottom: '$4',
  marginLeft: '$4',
});

export const HorizontalDrawerContainer = HStack.withConfig<{
  isStrongBorder?: boolean;
  isRevaultRequired?: boolean;
}>(p => ({
  alignItems: 'center',
  space: 3,
  borderTopWidth: 1,
  padding: '$3',
  borderTopColor: p.isStrongBorder ? primitive.bk.$bbqBrown : 'blackOpacity.10',
  width: 'full',
  backgroundColor: p.isRevaultRequired ? primitive.bk.$errorLight : null,
}));

export const HorizontalDrawerDesktopContainer = HStack.withConfig<{
  isStrongBorder?: boolean;
  isRevaultRequired?: boolean;
}>(p => ({
  width: 'full',
  alignItems: 'center',
  space: 3,
  borderTopWidth: 1,
  padding: '$3',
  borderTopColor: p.isStrongBorder ? primitive.bk.$bbqBrown : 'blackOpacity.10',
  backgroundColor: p.isRevaultRequired ? primitive.bk.$errorLight : null,
}));

export const ScrollableView = Box.withConfig({
  maxHeight: '450px',
  width: 'full',
  overflowY: 'scroll',
  paddingLeft: '$1',
  paddingRight: '$2',
});
